import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Carousel, Button } from 'antd';

import { crearMissatgeError } from '../../commons/missatgeServidor';
import ImatgeAmbControlError from '../commons/imatgeAmbControlError';

const missatgeErrorFotos = 'Error obtenint fotos d\'estació.';

const arrowPropTypes = {
    style: PropTypes.object,
    onClick: PropTypes.func,
    currentSlide: PropTypes.number,
    numeroTotalDeFotos: PropTypes.number
};

const NextArrow = (props) => {
    const { style, onClick, currentSlide, numeroTotalDeFotos } = props;

    const disabled = (currentSlide + 1 === numeroTotalDeFotos) ? true : false;

    return (
        <div className='estacio-detall-foto-arrow-right' style={{...style}} >
            <Button type="default" shape="circle" icon="right" onClick={onClick} size='small' disabled={disabled}/>
        </div>
    );
};
NextArrow.propTypes = arrowPropTypes;

const PrevArrow = (props) => {
    const { style, onClick, currentSlide } = props;

    const disabled = (currentSlide === 0) ? true : false;

    return (
        <div className='estacio-detall-foto-arrow-left' style={{...style}} >
            <Button type="default" shape="circle" icon="left" onClick={onClick} size='small' disabled={disabled}/>
        </div>
    );
};
PrevArrow.propTypes = arrowPropTypes;

const renderFoto = (fotos) => {
    return fotos.map((foto, index) => {
        return (
            <div key={index}>
                <ImatgeAmbControlError url={foto.url} classNameImg={'imatge-foto'}/>
            </div>
        );
    });
};

class EstacioDetallFoto extends Component {

    constructor(props) {
        super(props);

        this.state = {
            notificacioObertaPerErrorAFotos: false
        };

        this.onTancarNotificacioError = this.onTancarNotificacioError.bind(this);
    }

    shouldComponentUpdate(nextProps) {
        //Per evitar renders innecessaris
        return this.props.fotos !== nextProps.fotos;
    }

    configuracioCarousel(numeroTotalDeFotos) {
        return {
            dots: false,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            nextArrow: <NextArrow numeroTotalDeFotos={numeroTotalDeFotos} />,
            prevArrow: <PrevArrow />,
            arrows: true
        };
    }

    onTancarNotificacioError() {
        this.setState({notificacioObertaPerErrorAFotos: false});
    }

    /**
    * Retorna true si es donen les condicions per mostrar la notificació que indica
    * que ha hagut un error al recuperar les fotos.
    * @return {boolean}
    */
    shaDeCrearMissatgeError(){
        return !this.props.fotos && !this.state.notificacioObertaPerErrorAFotos;
    }

    componentWillMount() {
        if (this.shaDeCrearMissatgeError()) {
            crearMissatgeError(missatgeErrorFotos, null, this.onTancarNotificacioError);

            this.setState({notificacioObertaPerErrorAFotos: true});
        }
    }

    render() {
        const { fotos } = this.props;

        if (!fotos || fotos.length === 0) return null;

        const numeroTotalDeFotos = fotos.length;
        const configuracioCarousel = this.configuracioCarousel(numeroTotalDeFotos);

        return (
            <div className='estacio-detall-foto'>
                <Carousel className='estacio-detall-foto' {...configuracioCarousel} >
                    {renderFoto(fotos)}
                </Carousel>
            </div>
        );
    }
}

EstacioDetallFoto.propTypes = {
    fotos: PropTypes.array
};

export default EstacioDetallFoto;


// WEBPACK FOOTER //
// ./src/components/estacio/estacioDetallFoto.js